import { render, staticRenderFns } from "./ReportsHeader.vue?vue&type=template&id=3f308c05&scoped=true"
import script from "./ReportsHeader.vue?vue&type=script&lang=ts"
export * from "./ReportsHeader.vue?vue&type=script&lang=ts"
import style0 from "./ReportsHeader.vue?vue&type=style&index=0&id=3f308c05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f308c05",
  null
  
)

export default component.exports